import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../BaseUrl";

//LicentiateCertificate
export const LicentiateCertificateAPI = createAsyncThunk("LicentiateCertificate", async ({ data }) => {
    const { M_MainSubjectID, M_UserID, Flag, token } = data;

    // var myHeaders = new Headers();
    // myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: "GET",
        // headers: myHeaders,
        redirect: "follow",
    };
    return fetch(
        `${BaseUrl}/CommonDDLData/Get_DDL_M_MainSubject_Select?M_MainSubjectID=${M_MainSubjectID}&M_UserID=${M_UserID}&Flag=${Flag}`,
        requestOptions
    )
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data;
            } else {
                return result;
            }
        });
});

const LicentiateCertificateSlice = createSlice({
    name: "LicentiateCertificate",
    initialState: {
        isLoading: false,
        DDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(LicentiateCertificateAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(LicentiateCertificateAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.DDLData = action.payload;
        });
        builder.addCase(LicentiateCertificateAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.DDLData = null;
            // toastErrorr('Something went wrong')
        });
    },
});
export const LicentiateCertificateReducer = LicentiateCertificateSlice.reducer;

//LicentiateCertificateSubMenu
export const LicentiateCertificateSubMenuAPI = createAsyncThunk("LicentiateCertificateSubMenu", async ({ data }) => {
    const { M_MainSubjectID, M_UserID, Flag, token } = data;

    // var myHeaders = new Headers();
    // myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: "GET",
        // headers: myHeaders,
        redirect: "follow",
    };
    return fetch(
        `${BaseUrl}/CommonDDLData/Get_DDL_M_MainSubject_Select?M_MainSubjectID=${M_MainSubjectID}&M_UserID=${M_UserID}&Flag=${Flag}`,
        requestOptions
    )
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data;
            } else {
                return result;
            }
        });
});

const LicentiateCertificateSubMenuSlice = createSlice({
    name: "LicentiateCertificateSubMenu",
    initialState: {
        isLoading: false,
        DDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(LicentiateCertificateSubMenuAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(LicentiateCertificateSubMenuAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.DDLData = action.payload;
        });
        builder.addCase(LicentiateCertificateSubMenuAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.DDLData = null;
            // toastErrorr('Something went wrong')
        });
    },
});
export const LicentiateCertificateSubMenuReducer = LicentiateCertificateSubMenuSlice.reducer;


//LicentiateCertificateSubMenu
export const Optional_Subject_ListAPI = createAsyncThunk("Optional_Subject_List", async ({ data }) => {
    const { M_UserID, Flag, token } = data;

    // var myHeaders = new Headers();
    // myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: "GET",
        // headers: myHeaders,
        redirect: "follow",
    };
    return fetch(
        `${BaseUrl}/CommonDDLData/Get_DDL_M_Comman_Select?M_UserID=${M_UserID}&Flag=${Flag}`,
        requestOptions
    )
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data;
            } else {
                return result;
            }
        });
});

const Optional_Subject_ListSlice = createSlice({
    name: "Optional_Subject_List",
    initialState: {
        isLoading: false,
        DDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(Optional_Subject_ListAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(Optional_Subject_ListAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.DDLData = action.payload;
        });
        builder.addCase(Optional_Subject_ListAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.DDLData = null;
            // toastErrorr('Something went wrong')
        });
    },
});
export const Optional_Subject_ListReducer = Optional_Subject_ListSlice.reducer;

export const Week_Category_ListAPI = createAsyncThunk("Week_Category_List", async ({ data }) => {
    const { M_UserID, Flag, token } = data;

    // var myHeaders = new Headers();
    // myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: "GET",
        // headers: myHeaders,
        redirect: "follow",
    };
    return fetch(
        `${BaseUrl}/CommonDDLData/Get_DDL_M_Comman_Select?M_UserID=${M_UserID}&Flag=${Flag}`,
        requestOptions
    )
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data;
            } else {
                return result;
            }
        });
});

const Week_Category_ListSlice = createSlice({
    name: "Week_Category_List",
    initialState: {
        isWeekLoading: false,
        WeekData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(Week_Category_ListAPI.pending, (state, action) => {
            state.isWeekLoading = true;
        });
        builder.addCase(Week_Category_ListAPI.fulfilled, (state, action) => {
            state.isWeekLoading = false;
            state.WeekData = action.payload;
        });
        builder.addCase(Week_Category_ListAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isWeekLoading = false;
            state.isError = true;
            state.WeekData = null;
            // toastErrorr('Something went wrong')
        });
    },
});
export const Week_Category_ListReducer = Week_Category_ListSlice.reducer;

export const YearDDLAPI = createAsyncThunk("YearDDL", async ({ data }) => {
    const {
        M_UserID,
        token
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDDLData/Get_DDL_M_FinancialYear_Select?M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const YearDDLSlice = createSlice({
    name: "YearDDL",
    initialState: {
        isLoading: false,
        DDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(YearDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(YearDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.DDLData = action.payload;
        });
        builder.addCase(YearDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.DDLData = null;
            // toastErrorr('Something went wrong')
        });
    },
})
export const YearDDLReducer = YearDDLSlice.reducer

// Month DDL 

export const MonthDDLAPI = createAsyncThunk("MonthDDL", async ({ data }) => {
    const {
        M_UserID,
        token
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDDLData/Get_DDL_M_Month_Select?M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const MonthDDLSlice = createSlice({
    name: "MonthDDL",
    initialState: {
        isLoading: false,
        DDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(MonthDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(MonthDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.DDLData = action.payload;
        });
        builder.addCase(MonthDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.DDLData = null;
            // toastErrorr('Something went wrong')
        });
    },
})
export const MonthDDLReducer = MonthDDLSlice.reducer